import {
  askUserQuestionManifest,
  setElementTextContentTool,
  editRemoteFileTool,
  editRemoteFileExactTool,
  readPageTreeTool,
  readPageTool,
  readRemoteFileTool,
  renderCssTool,
  renderTool,
  applyStructuredBriefTool,
  renderVariablesTool,
  getHtmlFromQuerySelectorsTool,
  getHtmlFromSelectedElementTool,
  getHtmlFromTextTool,
  searchStylesTool,
  findUnusedStylesTool,
  deleteUnusedStylesTool,
  getAllSelectorsFromSiteTool,
  type ToolRegistryItem,
  writeRemoteFileTool,
  setCodeComponentStatesTool,
  writeRemoteFilesTool,
  testRunFunctionTool,
  deleteRemoteFilesTool,
  listFileTool,
  readFileTool,
  getFormNameTool,
  setFormNameTool,
  getFormInputRequiredTool,
  setFormInputRequiredTool,
  getFormInputTypeTool,
  setFormInputTypeTool,
  getFormInputNameTool,
  setFormInputNameTool,
  getFormSettingsTool,
  setFormSettingsTool,
} from '@packages/systems/ai/tool-registry/shared';

export const designerToolsMap: Partial<
  Record<ToolRegistryItem['id'], ToolRegistryItem>
> = {
  [askUserQuestionManifest.id]: askUserQuestionManifest,
  [setElementTextContentTool.id]: setElementTextContentTool,
  [editRemoteFileTool.id]: editRemoteFileTool,
  [editRemoteFileExactTool.id]: editRemoteFileExactTool,
  [readPageTreeTool.id]: readPageTreeTool,
  [readPageTool.id]: readPageTool,
  [readRemoteFileTool.id]: readRemoteFileTool,
  [writeRemoteFileTool.id]: writeRemoteFileTool,
  [setCodeComponentStatesTool.id]: setCodeComponentStatesTool,
  [writeRemoteFilesTool.id]: writeRemoteFilesTool,
  [testRunFunctionTool.id]: testRunFunctionTool,
  [deleteRemoteFilesTool.id]: deleteRemoteFilesTool,
  [renderCssTool.id]: renderCssTool,
  [renderTool.id]: renderTool,
  [applyStructuredBriefTool.id]: applyStructuredBriefTool,
  [renderVariablesTool.id]: renderVariablesTool,
  [getHtmlFromQuerySelectorsTool.id]: getHtmlFromQuerySelectorsTool,
  [getHtmlFromSelectedElementTool.id]: getHtmlFromSelectedElementTool,
  [getHtmlFromTextTool.id]: getHtmlFromTextTool,
  [getAllSelectorsFromSiteTool.id]: getAllSelectorsFromSiteTool,
  [searchStylesTool.id]: searchStylesTool,
  [findUnusedStylesTool.id]: findUnusedStylesTool,
  [deleteUnusedStylesTool.id]: deleteUnusedStylesTool,
  [listFileTool.id]: listFileTool,
  [readFileTool.id]: readFileTool,
  [getFormNameTool.id]: getFormNameTool,
  [setFormNameTool.id]: setFormNameTool,
  [getFormInputRequiredTool.id]: getFormInputRequiredTool,
  [setFormInputRequiredTool.id]: setFormInputRequiredTool,
  [getFormInputTypeTool.id]: getFormInputTypeTool,
  [setFormInputTypeTool.id]: setFormInputTypeTool,
  [getFormInputNameTool.id]: getFormInputNameTool,
  [setFormInputNameTool.id]: setFormInputNameTool,
  [getFormSettingsTool.id]: getFormSettingsTool,
  [setFormSettingsTool.id]: setFormSettingsTool,
};
